import React from 'react';
import { RouterProvider } from 'react-router-dom';

import Router from './routes/pages';
import { AuthConsumer, AuthProvider } from './authentication/context/jwt';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { CurrentColorContext, defaultColorScheme } from '@theme/theme-context';

const router = Router;

export default function App() {
  // useScrollToTop();

  const [colors, setColors] = React.useState(defaultColorScheme);

  axios.defaults.baseURL = process.env.API_BASE_URL; //'http://13.235.109.230:8081';
  axios.defaults.withCredentials = true;

  React.useEffect(() => {
    const _init = async () => {
      const result = window.localStorage.getItem('newColorScheme');
      if (result) setColors(JSON.parse(result));
    };

    _init();
  }, []);

  return (
    // <AuthProvider>
    //   <AuthConsumer>
    //     <RouterProvider router={router} />
    //     <ToastContainer />
    //   </AuthConsumer>
    // </AuthProvider>
    <>
      <CurrentColorContext.Provider value={{ colors, setColors }}>
        <style>{`
           :root {
            --color-primary-50: ${colors.primaryShades[50]};
            --color-primary-100: ${colors.primaryShades[100]};
            --color-primary-200: ${colors.primaryShades[200]};
            --color-primary-300: ${colors.primaryShades[300]};
            --color-primary-400: ${colors.primaryShades[400]};
            --color-primary-500: ${colors.primaryShades[500]};
            --color-primary-600: ${colors.primaryShades[600]};
            --color-primary-700: ${colors.primaryShades[700]};
            --color-primary-800: ${colors.primaryShades[800]};
            --color-primary-900: ${colors.primaryShades[900]};

            --color-secondary-50: ${colors.secondaryShades[50]};
            --color-secondary-100: ${colors.secondaryShades[100]};
            --color-secondary-200: ${colors.secondaryShades[200]};
            --color-secondary-300: ${colors.secondaryShades[300]};
            --color-secondary-400: ${colors.secondaryShades[400]};
            --color-secondary-500: ${colors.secondaryShades[500]};
            --color-secondary-600: ${colors.secondaryShades[600]};
            --color-secondary-700: ${colors.secondaryShades[700]};
            --color-secondary-800: ${colors.secondaryShades[800]};
            --color-secondary-900: ${colors.secondaryShades[900]};

            --color-tertiary-50: ${colors.tertiaryShades[50]};
            --color-tertiary-100: ${colors.tertiaryShades[100]};
            --color-tertiary-200: ${colors.tertiaryShades[200]};
            --color-tertiary-300: ${colors.tertiaryShades[300]};
            --color-tertiary-400: ${colors.tertiaryShades[400]};
            --color-tertiary-500: ${colors.tertiaryShades[500]};
            --color-tertiary-600: ${colors.tertiaryShades[600]};
            --color-tertiary-700: ${colors.tertiaryShades[700]};
            --color-tertiary-800: ${colors.tertiaryShades[800]};
            --color-tertiary-900: ${colors.tertiaryShades[900]};
            `}</style>

        <RouterProvider router={router} />
        <ToastContainer />
      </CurrentColorContext.Provider>
    </>
  );
}
